export const videoIds: Record<string, string> = {
  pt: "5WxsansyRv0",
  es: "ei93jMwhPLc",
  en: "WXMqPt4XT4I",
};
